import React, { useState } from 'react'
import "./CartContainer.css"
import { Col, Container, Row, Table } from 'react-bootstrap'
import axios from 'axios';

import { useDispatch, useSelector } from 'react-redux';
import AlertContainer from '../Alert/Alert';
import { fetchCart } from '../../hook/cart';
function CartContainer({ items }) {
  const [show, setShow] = useState(false);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [msg, setMsg] = useState('');
  const [severity, setSeverity] = useState('');
  const dispatch = useDispatch()

  const userinfo = useSelector((state) => state);

  const deleteCart = async (id) => {
    await axios
      .delete(`https://nanosoft.technology/smile/api/cart/${id}`,

        {
          headers: {
            Authorization: `Bearer ${userinfo?.auth?.access_token}`
          }
        })

      .then(async (res) => {
        dispatch(fetchCart());
        setShow(true)
        setMsg(currentLocal.home.deletesuccessMessage)
        setSeverity("success")

        setTimeout(() => {
          setShow(false)
        }, 1500);
        // toast.success("cart Delete successfully", {
        //   position: "bottom-right",
        //   autoClose: 3000,
        //   rtl: currentLocal.language === "العربيه",
        // });
      })
      .catch((error) => {



      });
  }
  return (
    <div>
      {show &&
        <AlertContainer
          msg={msg}
          severity={severity}
        />

      }
      {/* <Toast onClose={() => setShow(false)} show={show} delay={5000} autohide>
        <Toast.Header className='d-flex justify-content-between border-0 py-1'>
          <p></p>
          <img
            src="holder.js/20x20?text=%20"
            className="rounded me-2"
            alt=""
          />
        </Toast.Header>
        <Toast.Body className='text-center'>{alert}</Toast.Body>
      </Toast> */}
      {/* {items && items[0]?.products.map((cartItem, index) => {
        console.log(cartItem && cartItem?.product_name);

        return (
          <Container fluid key={index}>

    
          </Container>
        )
      })} */}
      <Table responsive size="sm">
        <thead>
          <tr>
            <td className='fw-bold'>  {currentLocal.home.products}</td>
            <td className='fw-bold'>  {currentLocal.home.Quantity}</td>
            <td className='fw-bold'>  {currentLocal.home.price}</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {items && items[0]?.products?.map((cartItem, index) => {

            console.log(cartItem);

            return (
              <tr>
                <td className='w-25 h-25'>
                  <div className='me-3 w-100'>
                    <img src={cartItem.product && cartItem?.product?.images[0]?.image} alt='' className='w-50' />
                  </div>
                  <div>
                    <span className='product_name'>{cartItem && currentLocal.language === "English" ? cartItem?.product?.name_en : cartItem?.product?.name_ar}</span>

                  </div>

                </td>
                <td>
                  <div className='price fw-bold text-center'>


                    <p>                             {cartItem && cartItem.quantity}
                    </p>
                  </div>
                </td>
                <td>
                  <div className='price fw-bold '>

                    {cartItem?.total?.discounted_subtotal_egp ?
                      <p >
                        LE {cartItem && Number(cartItem.subtotal_egp).toFixed(2)}
                      </p>
                      :

                      <div className=''>

                        <p>
                          LE {cartItem && Number(cartItem.total_price_egp).toFixed(2)}={cartItem.quantity}*{cartItem.discounted_price_egp}
                        </p>

                        <p
                          className='mx-2 mb-0'
                          style={{
                            textDecoration: "line-through"
                          }}>
                          LE {cartItem && Number(cartItem.subtotal_egp).toFixed(2)}={cartItem.quantity}*{cartItem.unit_price_egp}
                        </p>
                      </div>
                    }

                  </div>
                </td>
                <td className=''>
                  <div className='d-flex justify-content-center align-items-center h-100'>
                    <p className='text-primary ' style={{ cursor: "pointer" }}
                      onClick={() => deleteCart(cartItem.id)}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="red" class="bi bi-trash3" viewBox="0 0 16 16">
                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                      </svg>
                    </p>
                  </div>
                </td>
              </tr>
            )
          })}

        </tbody>
      </Table>





    </div>
  )
}

export default CartContainer